export const INSTITUTION_CHECK_REQUEST = 'INSTITUTION_CHECK_REQUEST';
export const INSTITUTION_CHECK_SUCCESS = 'INSTITUTION_CHECK_SUCCESS';
export const INSTITUTION_CHECK_FAILURE = 'INSTITUTION_CHECK_FAILURE';
